module.exports = __webpack_public_path__ + "img/quant_pt.4fe361a9.png";